"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _find = _interopRequireDefault(require("lodash/find"));

var _get = _interopRequireDefault(require("lodash/get"));

var _head = _interopRequireDefault(require("lodash/head"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _useFetchAsJson3 = _interopRequireDefault(require("@eig-builder/core-utils/hooks/useFetchAsJson"));

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var _siteSelectorContext = require("../context/site-selector-context");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var init = {
  siteId: null,
  site: null,
  sites: null,
  isLoading: true
};

function siteIdFromLocalStorage() {
  // Read current site from localstorage
  var lsSiteId = null;

  try {
    lsSiteId = window && Number(window.localStorage.getItem('CURRENT_SITE'));
    lsSiteId = isNaN(lsSiteId) ? null : lsSiteId;
  } catch (_unused) {// Could not write to localstorage
  }

  return lsSiteId;
}

function siteIdFromQueryString() {
  // Read current site from the url
  var qpSiteId = null;

  if (!window) {
    return qpSiteId;
  }

  var params = (0, _urlHelper.getQueryParametersFromUrl)(window.location.search);
  qpSiteId = params.siteid ? Number(params.siteid) : null;
  qpSiteId = isNaN(qpSiteId) ? null : qpSiteId;
  return qpSiteId;
}

function reducer(state, action) {
  switch (action.type) {
    case 'setSite':
      var siteId = (0, _get["default"])(action.payload, 'id', null);

      if (siteId) {
        try {
          window && window.localStorage.setItem('CURRENT_SITE', siteId);
        } catch (_unused2) {// Could not write to localstorage
        }
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        siteId: siteId,
        site: action.payload
      });

    case 'setSitesAndId':
      var qpSiteId = siteIdFromQueryString();
      var lsSiteId = siteIdFromLocalStorage(); // Do not override the siteId when it is already set

      var selectedSiteId = state.siteId || action.payload.siteId || qpSiteId || lsSiteId; // Find the site in the sites list, if not found (ie incorrect siteid) pick the first site from the array

      var currentSite = (0, _find["default"])(action.payload.sites, {
        id: selectedSiteId
      }) || (0, _head["default"])(action.payload.sites);
      var currentSiteId = (0, _get["default"])(currentSite, 'id');

      if (currentSiteId) {
        try {
          window && window.localStorage.setItem('CURRENT_SITE', currentSiteId);
        } catch (_unused3) {// Could not write to localstorage
        }
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        sites: action.payload.sites,
        site: currentSite,
        siteId: currentSiteId,
        isLoading: false
      });

    case 'reset':
      return init;

    default:
      throw new Error();
  }
}

var SiteSelectorWrapper = function SiteSelectorWrapper(_ref) {
  var children = _ref.children;

  var _useReducer = (0, _react.useReducer)(reducer, init),
      _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
      provider = _useReducer2[0],
      dispatch = _useReducer2[1];

  var _useFetchAsJson = (0, _useFetchAsJson3["default"])({
    url: (0, _urlHelper.api)('v1.1/sites', 'control-panel')
  }),
      _useFetchAsJson2 = (0, _slicedToArray2["default"])(_useFetchAsJson, 1),
      data = _useFetchAsJson2[0];

  (0, _react.useEffect)(function () {
    if (data.isLoading === false && (0, _isNil["default"])(data.data) === false) {
      dispatch({
        type: 'setSitesAndId',
        payload: {
          sites: data.data
        }
      });
    }
  }, [data, dispatch]);
  return /*#__PURE__*/_react["default"].createElement(_siteSelectorContext.SiteSelectorContext.Provider, {
    value: provider
  }, /*#__PURE__*/_react["default"].createElement(_siteSelectorContext.SiteSelectorDispatchContext.Provider, {
    value: dispatch
  }, children));
};

SiteSelectorWrapper.propTypes = {
  children: _propTypes["default"].any
};

var _default = (0, _react.memo)(SiteSelectorWrapper);

exports["default"] = _default;